import { ref } from 'vue'

/**
 * useTheme — placeholder V1.
 *
 * Le mode dark est différé V1.5 (la palette olivine n'a pas encore son
 * pendant sombre). Le composable est conservé pour ne pas casser les
 * usages existants (`useTheme().theme`), mais set/toggle sont no-op et
 * la classe `.p-dark` n'est jamais appliquée sur <html>.
 *
 * Cf. PRELLM_SPEC.md §14.6 — réactivation prévue avec une palette
 * « Encre & Olivine — nuit » (bg #0F1418, etc.) à dériver depuis ink-2.
 */

export type Theme = 'light' | 'dark'

const theme = ref<Theme>('light')

export function useTheme() {
    function set(_value: Theme): void {
        // no-op V1
    }
    function toggle(): void {
        // no-op V1
    }
    return { theme, set, toggle }
}
